import { useTranslation } from 'react-i18next';
import styles from './FilterChips.module.css';

export type FilterPeriod = 'all' | 'today' | 'yesterday' | 'week' | 'month';

interface FilterChipsProps {
  selected: FilterPeriod;
  onChange: (period: FilterPeriod) => void;
}

export const FilterChips = ({ selected, onChange }: FilterChipsProps) => {
  const { t } = useTranslation();

  const filters: { value: FilterPeriod; label: string }[] = [
    { value: 'all', label: 'Todos' },
    { value: 'today', label: t('links.today') },
    { value: 'yesterday', label: t('links.yesterday') },
    { value: 'week', label: t('links.thisWeek') },
    { value: 'month', label: t('links.thisMonth') },
  ];

  return (
    <div className={styles.container}>
      {filters.map((filter) => (
        <button
          key={filter.value}
          className={`${styles.chip} ${selected === filter.value ? styles.active : ''}`}
          onClick={() => onChange(filter.value)}
          type="button"
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};

